export default "__VITE_ASSET__129a93ca__"